import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@shared/components/ui/collapsible';
import { useEventTranslation } from '../hooks/useEventTranslation';
import { useBookingFlow } from '../flow';
import { sanitizeHtml } from '@shared/utils/sanitize';

export function EventBanner() {
  const event = useEventTranslation();
  const { isFirstStep, currentStep } = useBookingFlow();
  const { t } = useTranslation('booking');

  if (!event) return null;
  if (currentStep === null) return null;

  const hasDescription = !!event.description;

  const titleSpan = (
    <span className="text-xs uppercase tracking-[0.12em] font-medium text-brand-dark text-center text-balance">
      {event.title}
    </span>
  );

  if (!hasDescription) {
    return (
      <div className="flex items-center justify-center gap-3 px-6 pt-4">
        <span aria-hidden="true" className="w-8 h-px shrink-0 bg-brand/30" />
        {titleSpan}
        <span aria-hidden="true" className="w-8 h-px shrink-0 bg-brand/30" />
      </div>
    );
  }

  return (
    <Collapsible defaultOpen={isFirstStep} className="pt-4">
      <CollapsibleTrigger
        className="group w-full flex items-center justify-center gap-3 px-6 py-1 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-1"
        aria-label={t('EVENT_TOGGLE_DETAILS')}
      >
        <span aria-hidden="true" className="w-8 h-px shrink-0 bg-brand/30" />
        {titleSpan}
        <ChevronDown
          size={12}
          className="text-brand-dark transition-transform duration-200 group-data-[state=open]:rotate-180 shrink-0"
          aria-hidden="true"
        />
        <span aria-hidden="true" className="w-8 h-px shrink-0 bg-brand/30" />
      </CollapsibleTrigger>
      <CollapsibleContent className="px-6 pt-2">
        <div
          className="text-sm text-foreground/60 text-center max-w-lg mx-auto"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(event.description) }}
        />
      </CollapsibleContent>
    </Collapsible>
  );
}

export default EventBanner;
